import { forwardRef, ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface IconInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Icon element to display on the left side */
  icon: ReactNode;
}

/**
 * Input field with a leading icon
 * Properly centers the icon vertically using transform
 */
export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(
  ({ icon, className, ...props }, ref) => {
    return (
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
          {icon}
        </div>
        <Input
          ref={ref}
          className={cn('pl-9 bg-background border-border', className)}
          {...props}
        />
      </div>
    );
  }
);
IconInput.displayName = 'IconInput';
